/**
 * 医药、处方相关接口
 * @author haoru
 */

import { ApiConfigs, Response } from '@schemas/service';
import {
  IShippingAddress,
  IBoundDoctorList,
  IUnboundDoctorList,
  IOrderDrugstoreList,
  IMedUserOrderListResult,
  INonprescription,
  TCreateAndSendRecommendGoods,
  TQueryRecommendGoods,
  TCreateRecommendGoodsPreOrder,
  TCreatePrescriptionPreOrder,
  IDoctorDrugStore,
  IKsStoreGoodsList,
  TSendRecommendGoodsForKwaiXiaoDianParam
} from '@/schemas/med';

import { checkResponse } from '@/utils/helpers';
import { request, TAxiosRequestConfig } from './request';

const api: ApiConfigs = {
  // "我的收货地址"-地址列表
  queryShippingAddressList: {
    url: '/health/api/v1/address/queryAddressList',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/address/queryAddressList',
    method: 'GET'
  },
  // 查询地址信息
  queryShippingAddressInfo: {
    url: '/health/api/v1/address/queryAddressInfoById',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/address/queryAddressInfoById',
    method: 'GET'
  },
  // 修改地址信息
  editShippingAddressInfo: {
    url: '/health/api/v1/address/updateAddress',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/address/updateAddress',
    method: 'PUT'
  },
  // 添加收货地址
  addShippingAddress: {
    url: '/health/api/v1/address/createAddress',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/address/createAddress',
    method: 'POST'
  },
  // 删除收货地址
  deleteShippingAddress: {
    url: '/health/api/v1/address/deleteAddress',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/address/deleteAddress',
    method: 'DELETE'
  },
  // 查询开方医生被绑定的医生列表
  queryBoundDoctorList: {
    url:
      '/health/api/v1/doctorEnd/workbench/queryPrescriberBindingByPrescriber',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/doctorEnd/workbench/queryPrescriberBindingByPrescriber',
    method: 'GET'
  },
  // "开方医师页"-查询未绑定的开方医师列表
  queryUnboundDoctorList: {
    url: '/health/api/v1/doctorEnd/workbench/queryUnboundPrescriberByDoctor',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/doctorEnd/workbench/queryUnboundPrescriberByDoctor',
    method: 'GET'
  },
  // "开方医师页"-点击同意绑定开方医师
  bindPrescriber: {
    url: '/health/api/v1/doctorEnd/workbench/bindPrescriber',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/doctorEnd/workbench/bindPrescriber',
    method: 'GET'
  },
  // "开方医师页"-查询已绑定的开方医师列表
  queryBindingDoctorList: {
    url: '/health/api/v1/doctorEnd/workbench/queryPrescriberBindingByDoctor',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/doctorEnd/workbench/queryPrescriberBindingByDoctor',
    method: 'GET'
  },
  // "开方医师页"-点击同意解绑开方医师
  unbindPrescriber: {
    url: '/health/api/v1/doctorEnd/workbench/unbindPrescriber',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/doctorEnd/workbench/unbindPrescriber',
    method: 'GET'
  },
  queryOrderDrugstoreList: {
    url: '/health/api/v1/drug/queryDrugstoreList',
    method: 'POST'
  },
  queryOrderList: {
    url: '/health/api/v1/drug/queryOrderList',
    method: 'GET'
  },
  createPrescriptionPreOrder: {
    url: '/health/api/v1/drug/createPrescriptionPreOrder',
    method: 'POST'
  },
  queryNonprescriptionDetail: {
    url: '/health/api/v1/drug/queryDrug',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058//health/api/v1/drug/queryDrug',
    method: 'GET'
  },
  // 医生创建并发送商品建议
  createAndSendRecommendGoods: {
    url: '/health/api/v1/drug/createAndSendRecommendGoods',
    method: 'POST'
  },
  // 查看商品建议单详情
  queryRecommendGoods: {
    url: '/health/api/v1/drug/queryRecommendGoods',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/drug/queryRecommendGoods',
    method: 'GET'
  },
  // 用户预创建商品建议订单，返回第三方 跳转链接
  createRecommendGoodsPreOrder: {
    url: '/health/api/v1/drug/createRecommendGoodsPreOrder',
    method: 'POST'
  },
  // 医生端 - 选择店铺页
  queryDoctorDrugStoreList: {
    url: '/health/api/v1/drug/queryDrugstore',
    method: 'GET'
  },
  // 医生端 - 选择商品页
  getKsStoreGoodList: {
    url: '/health/api/v1/drug/ksStoreGoodList',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/drug/ksStoreGoodList',
    method: 'GET'
  },
  // 用户端 - 删除购药订单
  removeOrderView: {
    url: '/health/api/v1/drug/removeOrderView',
    method: 'GET'
  },
  // 医生端 - 询问病史
  requestPatientInfo: {
    url: '/health/api/v1/drug/requestPatientInfo',
    method: 'GET'
  },
  // 医生端 - 推荐小店商品
  sendRecommendGoodsForKwaiXiaoDian: {
    url: '/health/api/v1/drug/sendRecommendGoodsForKwaiXiaoDian',
    method: 'POST'
  },
  // 医生端 - 获取好物联盟地址
  getGoodAllianceUrl: {
    url: '/health/api/v1/drug/getGoodAllianceUrl',
    method: 'GET'
  }
};

const med = {
  async getShippingAddressList() {
    try {
      const response: Response<IShippingAddress[] | null> = await request(
        api.queryShippingAddressList,
        undefined,
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getShippingAddressInfo(id) {
    try {
      const response: Response<IShippingAddress | null> = await request(
        api.queryShippingAddressInfo,
        {
          id
        },
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async editShippingAddressInfo(addressInfo) {
    try {
      const response: Response = await request(
        api.editShippingAddressInfo,
        {},
        addressInfo,
        {
          hideGlobalLoading: false
        }
      );
      const { result } = response;
      if (result) {
        return true;
      }
      return false;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async addShippingAddress(addressInfo) {
    try {
      const response: Response = await request(
        api.addShippingAddress,
        {},
        addressInfo,
        {
          hideGlobalLoading: false
        }
      );
      const { result } = response;
      if (result) {
        return true;
      }
      return false;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async deleteShippingAddress(id) {
    try {
      const response: Response = await request(
        api.deleteShippingAddress,
        {
          id
        },
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { result } = response;
      if (result) {
        return true;
      }
      return false;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getBoundDoctorList({ pageNum = 1, pageSize = 7 }) {
    try {
      const response: Response<IBoundDoctorList | null> = await request(
        api.queryBoundDoctorList,
        {
          pageNum,
          pageSize
        },
        undefined,
        { hideGlobalLoading: false }
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getUnboundDoctorList({ pageNum = 1, pageSize = 7 }) {
    try {
      const response: Response<IUnboundDoctorList | null> = await request(
        api.queryUnboundDoctorList,
        {
          pageNum,
          pageSize
        },
        undefined,
        { hideGlobalLoading: false }
      );
      const { result } = response;
      if (result) {
        const mapedList = result.list.map((item) => {
          const ret = { ...item, isBind: false };
          return ret;
        });
        return { ...result, list: mapedList };
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async bindPrescriber(prescriberId) {
    try {
      const response: Response = await request(
        api.bindPrescriber,
        {
          prescriberId
        },
        undefined,
        { hideGlobalLoading: false }
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getBindingDoctorList({ pageNum = 1, pageSize = 1000 }) {
    try {
      const response: Response<IBoundDoctorList | null> = await request(
        api.queryBindingDoctorList,
        {
          pageNum,
          pageSize
        },
        undefined,
        { hideGlobalLoading: false }
      );
      const { result } = response;
      if (result) {
        const mapedList = result.list.map((item) => {
          // eslint-disable-next-line no-param-reassign
          item.doctorInfo.isBind = true;
          return item;
        });
        return { ...result, list: mapedList };
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async unbindPrescriber(id) {
    try {
      const response: Response = await request(
        api.unbindPrescriber,
        {
          id
        },
        undefined,
        { hideGlobalLoading: false }
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getOrderDrugstoreList({ addressId, drugUsages }) {
    try {
      const response: Response = await request(
        api.queryOrderDrugstoreList,
        undefined,
        { addressId, drugUsages },
        { hideGlobalLoading: false }
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return {} as IOrderDrugstoreList;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async queryOrderList({ pageNum, pageSize, status }) {
    try {
      const response: Response<IMedUserOrderListResult> = await request(
        api.queryOrderList,
        { pageNum, pageSize, status }
      );
      const { code, result } = response;
      if (checkResponse(code, result)) {
        return result;
      }
      return Promise.reject(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async createPrescriptionPreOrder(params: TCreatePrescriptionPreOrder) {
    try {
      const response: Response<string> = await request(
        api.createPrescriptionPreOrder,
        undefined,
        { ...params },
        { hideGlobalLoading: false, hideWeakNetworkToast: true }
      );
      const { code, result } = response;
      if (checkResponse(code, result)) {
        return result;
      }
      return Promise.reject(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getNonprescriptionDetail(drugId, merchantShopSkuId, source) {
    try {
      const response: Response<INonprescription | null> = await request(
        api.queryNonprescriptionDetail,
        {
          drugId,
          merchantShopSkuId,
          source
        },
        undefined,
        { hideGlobalLoading: false }
      );
      const { code, result } = response;
      if (checkResponse(code, result)) {
        return result;
      }
      return Promise.reject(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async createAndSendRecommendGoods(params: TCreateAndSendRecommendGoods) {
    try {
      const response: Response<boolean> = await request(
        api.createAndSendRecommendGoods,
        undefined,
        { ...params },
        { hideGlobalLoading: false }
      );
      const { code, result } = response;
      if (checkResponse(code, result)) {
        return result;
      }
      return Promise.reject(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async queryRecommendGoods(recommendGoodsId: number) {
    try {
      const response: Response<TQueryRecommendGoods> = await request(
        api.queryRecommendGoods,
        { recommendGoodsId },
        undefined,
        { hideGlobalLoading: false }
      );
      const { code, result } = response;
      if (checkResponse(code, result)) {
        return result as TQueryRecommendGoods;
      }
      return Promise.reject(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async createRecommendGoodsPreOrder(params: TCreateRecommendGoodsPreOrder) {
    try {
      const response: Response<string> = await request(
        api.createRecommendGoodsPreOrder,
        undefined,
        { ...params },
        { hideGlobalLoading: false, hideWeakNetworkToast: true }
      );
      const { code, result } = response;
      if (checkResponse(code, result)) {
        return result;
      }
      return Promise.reject(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getDoctorDrugStoreList() {
    try {
      const response: Response<IDoctorDrugStore[] | null> = await request(
        api.queryDoctorDrugStoreList,
        undefined,
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getKsStoreGoodList(
    { pageNum = 1, pageSize = 1000, consultOrderId },
    config?: TAxiosRequestConfig
  ) {
    try {
      const response: Response<IKsStoreGoodsList> = await request(
        api.getKsStoreGoodList,
        {
          pageNum,
          pageSize,
          consultOrderId
        },
        undefined,
        config
      );
      const { code, result } = response;
      if (checkResponse(code, result)) {
        return result;
      }
      return Promise.reject(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async removeOrderView(source: number, tpOrderId: string) {
    try {
      const response: Response = await request(
        api.removeOrderView,
        {
          source,
          tpOrderId
        },
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { code, result } = response;
      if (checkResponse(code, result)) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async requestPatientInfo(orderId) {
    try {
      const response: Response<boolean> = await request(
        api.requestPatientInfo,
        { orderId },
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async sendRecommendGoodsForKwaiXiaoDian(
    params: TSendRecommendGoodsForKwaiXiaoDianParam
  ) {
    try {
      const response: Response<boolean> = await request(
        api.sendRecommendGoodsForKwaiXiaoDian,
        undefined,
        { ...params },
        { hideGlobalLoading: false, hideWeakNetworkToast: true }
      );
      const { code, result } = response;
      if (checkResponse(code, result)) {
        return result;
      }
      return Promise.reject(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getGoodAllianceUrl() {
    try {
      const response: Response<string> = await request(
        api.getGoodAllianceUrl,
        undefined,
        undefined,
        {
          hideWeakNetworkToast: true
        }
      );
      const { code, result } = response;
      if (checkResponse(code, result)) {
        return result;
      }
      return Promise.reject(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default med;
